export const FileUploadMixin = {
  methods: {
    handleChange(file, fileList) {
      this.$log.debug('handleChange', file.size)
      const size = process.env.VUE_APP_LIMIT_FILE_UPLOAD | 10
      const limit = file.size / 1024 / 1024 < size
      if (!limit) {
        this.showError(`El documento adjunto no puede exceder los ${size}MB`)
        fileList.pop()
        return false
      }
      this.createBase64Image(file.raw)

    },
    createBase64Image(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.model.documento = e.target.result
      };
      reader.readAsDataURL(file);
    },
    handleRemove(file, fileList) {
      this.$log.debug('handleRemove', file.size)
      this.model.documento = ''
    }
  }
}
